import React from 'react';
import { Box } from '@mui/material';
import Token from '../token.png';
const Logo = ({sx}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        borderRadius: 2,
        p: 1,
        m:1,
        minWidth: 48,
        height: 60,
        justifyContent: 'center',
        backgroundColor:"white",
        ...sx, 
      }}
    >
      <Box
        component="img"
        src={Token}
        alt="Token Logo"
        sx={{ width: 200, height: 60 }} 
      />
    </Box>
  );
};

export default Logo;

